import React from 'react'
import AboutIcon from '../../assets/img/logo/favicon.png';
import { Link } from 'react-router-dom';
import empowerImg from '../../assets/img/empower.png'
import CardImg from '../../assets/img/send.png'
import { Helmet } from "react-helmet-async";
import { isStaging } from '../../utils/env';

function SendMoney() {
    const dashboardBaseUrl = process.env.REACT_APP_DASHBOARD_BASE_URL;
    return (
        <>
            <Helmet>
                <title>Send Money</title>
                <meta name="description" content="Send Money" />
                <meta name="keywords" content="Send Money" />
                <meta name="robots" content={process.env.REACT_APP_ROBOTS || (isStaging ? "noindex, nofollow" : "index, follow")} />
                <meta property="og:title" content="Send Money" />
                <meta property="og:description" content="Send Money" />
            </Helmet>
            <section className='breadcrumb__section__02 padding__tb__100'>
                <div className="container">
                    <div className='row'>
                        <div className='col-md-12'>
                            <div className="breadcrumb__title__head">
                                <ol className="breadcrumb">
                                    <li className="active"><img src={AboutIcon} style={{ width: '25px', height: '25px' }} alt="" /></li>
                                </ol>
                                <h2 className='breadcrumb__title'> FEATURES </h2>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="breadcrumb__text">
                                <h3 className='breadcrumb__text__head'>Send Money</h3>
                                <p className='breadcrumb__text__content '>
                                    Sending money should be as simple as sending a message. At Cardplot, we’re reimagining how Africans connect financially with one another, empowering you to transfer funds across borders quickly, securely, and affordably. Our Send Money feature is built for individuals, families, and businesses navigating Africa’s vibrant and interconnected landscape.
                                </p>
                            </div>
                            <div className='d-flex gap-3 justify-content-center align-items-center' style={{ paddingTop: '40px' }}>
                                <Link to='/send_money' className='btn btn__primary'>Send Money</Link>
                                <Link to='/contact' className='btn btn__outline_primary '>Contact us</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className='virtual__section padding__tb__50'>
                <div className='container'>
                    <div className='row justify-content-center align-items-center' style={{ paddingBottom: '100px' }}>
                        <div className='col-12 col-md-6 mb-4 mb-lg-0 '>
                            <div className='virtual__section__content'>
                                <h3 className='virtual__section__title'>
                                  Stay Connected and seize opportunities, no matter where you are in Africa
                                </h3>
                                <a className='btn btn__primary mt-4' href={`${dashboardBaseUrl}/getstarted`} target="_blank" rel="noopener noreferrer">
                                    Get Started
                                </a>
                            </div>
                        </div>
                        <div className='col-12 col-md-6 mb-4 mb-lg-0 '>
                            <div className=''>
                                <img src={CardImg} className='img-fluid' alt='virtual cards' />
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className='create__virtual__card__section padding__tb__50'>
                <div className='container'>
                    <div className='row'>
                        <div className='col-md-12'>
                            <div className='position-relative'>
                                <h2 className='create__virtual__card__section__title'>What you get:</h2>
                            </div>
                        </div>
                    </div>
                    <div className='create__virtual__account__section__content'>
                        <div className='create__virtual__account__section__content_right'>
                            <div className='create__virtual__card__section__content__item'>
                                <div className='create__virtual__card__section__content__item__box mb-4'>
                                    <div className='create__virtual__card__section__content__item__box__icon'>
                                        1
                                    </div>
                                    <div className='create__virtual__account__item'>
                                        <h4>Fast and Reliable Transfers</h4>
                                        <p>Send money instantly, with real-time updates on the progress of your transactions. We ensure your funds reach their destination without delays.</p>
                                    </div>
                                </div>
                                <div className='create__virtual__card__section__content__item__box mb-4'>
                                    <div className='create__virtual__card__section__content__item__box__icon'>
                                        2
                                    </div>
                                    <div className='create__virtual__account__item'>
                                        <h4>Affordable and Transparent</h4>
                                        <p>Forget about hidden charges. Our rates are competitive and transparent, ensuring your money goes further, empowering you to do more.</p>
                                    </div>
                                </div>
                                <div className='create__virtual__card__section__content__item__box mb-4'>
                                    <div className='create__virtual__card__section__content__item__box__icon'>
                                        3
                                    </div>
                                    <div className='create__virtual__account__item'>
                                        <h4>Secure and Trustworthy</h4>
                                        <p>Built with state-of-the-art encryption and security protocols, Cardplot ensures your transfers are safe from start to finish.
                                        </p>
                                    </div>
                                </div>
                                <div className='create__virtual__card__section__content__item__box mb-4'>
                                    <div className='create__virtual__card__section__content__item__box__icon'>
                                        4
                                    </div>
                                    <div className='create__virtual__account__item'>
                                        <h4>Pan-African Focus</h4>
                                        <p>Designed with Africa’s unique financial ecosystem in mind, our platform integrates local currencies and payment systems, making transfers effortless.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className='empower_your_trade overlay'>
                <div className="container">
                    <div className="row justify-content-center align-items-center">
                        <div className="col-12 col-lg-6 mb-4 mb-lg-0">
                            <div className="empower__title">
                                <h2>Ready to simplify your payments?</h2>
                                <p>Simplify Your Exchange, Empower Your Trade</p>
                                <div className='d-flex gap-3' style={{ paddingTop: '60px' }}>
                                    <a className='btn btn__primary' href={`${dashboardBaseUrl}/getstarted`} target="_blank" rel="noopener noreferrer">
                                        Get Started
                                    </a>
                                    <Link to='/contact' className='btn btn__outline_primary'>Contact us</Link>
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-lg-6 mb-4 mb-lg-0">
                            <div className="empower__img">
                                <img src={empowerImg} className='img-fluid' alt="empower" />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default SendMoney